import { Link } from "@/lib/nav";

import SectionCard from "@buildpy/ui/section-card";
import { Button } from "@buildpy/ui/button";
import CustomerForm from "@/modules/customer/ui/customer-form";
import type { CustomerNewView } from "@buildpy/core/views/g1a/customer-new";
import PageHeader from "@/shell/page-header";

// 고객 등록 — 상담 전화를 받으면서 채우는 화면이라 필수는 이름·휴대폰 둘뿐이다.
const Page = ({ data }: { data: CustomerNewView }) => {
  const { codes, members, pasteOwn, consultTrades } = data;

  return (
    <>
      <PageHeader
        actions={
          <Button asChild size="sm" variant="outline">
            <Link href="/app/customers">목록</Link>
          </Button>
        }
        description="이름과 휴대폰만 있으면 저장됩니다."
        title="고객 등록"
      />

      <SectionCard as="div" className="lg:p-6">
        <CustomerForm
          codes={codes}
          members={members}
          pasteOwn={pasteOwn}
          trades={consultTrades}
        />
      </SectionCard>
    </>
  );
};

export default Page;
